import { readIAiCsvEnv, readIAiProcessEnv } from "./platform-url-env";
import {
  isLocalDevelopmentHost,
  normalizeHostname,
  resolveEffectiveHostname,
} from "./platform-url-utils";
export {
  getIAiViteAllowedHosts,
  getIAiViteHmrOptions,
  requireIAiViteHmrHost,
} from "./vite-config";
export type { IAiViteConfigEnv, IAiViteHmrOptions } from "./vite-config";

export function resolvePlatformRootDomain(hostname?: string) {
  const configuredRootDomains = getIAiPlatformRootDomains();
  const normalizedHostname = resolveEffectiveHostname(hostname);
  if (!normalizedHostname) {
    return "";
  }
  for (const rootDomain of configuredRootDomains) {
    if (normalizedHostname === rootDomain || normalizedHostname.endsWith(`.${rootDomain}`)) {
      return rootDomain;
    }
  }
  if (configuredRootDomains.length === 0) {
    return resolveRootDomainFromHostname(normalizedHostname);
  }
  return "";
}

export function getIAiPlatformRootDomains() {
  const configuredRootDomains = readIAiCsvEnv("PUBLIC_ROOT_DOMAINS");
  if (configuredRootDomains.length > 0) {
    return configuredRootDomains;
  }
  const singleConfiguredRootDomain =
    readIAiProcessEnv("PUBLIC_ROOT_DOMAIN") || readIAiProcessEnv("AIRANGE_ROOT_DOMAIN");
  if (singleConfiguredRootDomain) {
    return [singleConfiguredRootDomain];
  }
  if (typeof window !== "undefined") {
    const resolvedFromWindow = resolveRootDomainFromHostname(window.location.hostname);
    if (resolvedFromWindow) {
      return [resolvedFromWindow];
    }
  }
  return [];
}

function resolveRootDomainFromHostname(hostname?: string) {
  const normalizedHostname = normalizeHostname(hostname);
  if (!normalizedHostname || isLocalDevelopmentHost(normalizedHostname)) {
    return "";
  }
  if (/^\d+\.\d+\.\d+\.\d+$/.test(normalizedHostname)) {
    return "";
  }
  const segments = normalizedHostname.split(".").filter(Boolean);
  if (segments.length < 2) {
    return "";
  }
  const wildcardIpRootDomain = resolveWildcardIpRootDomain(segments);
  if (wildcardIpRootDomain) {
    return wildcardIpRootDomain;
  }
  return segments.slice(-2).join(".");
}

function resolveWildcardIpRootDomain(segments: string[]) {
  const wildcardProvider = segments.slice(-2).join(".");
  if (wildcardProvider !== "sslip.io" && wildcardProvider !== "nip.io") {
    return "";
  }
  for (let index = 0; index <= segments.length - 6; index += 1) {
    const candidateIpLabels = segments.slice(index, index + 4);
    if (
      candidateIpLabels.every((segment) => {
        if (!/^\d{1,3}$/.test(segment)) {
          return false;
        }
        const value = Number(segment);
        return Number.isInteger(value) && value >= 0 && value <= 255;
      })
    ) {
      return [...candidateIpLabels, wildcardProvider].join(".");
    }
  }
  return "";
}

export function isIAiPlatformHost(hostname: string) {
  return resolvePlatformRootDomain(hostname).length > 0;
}

export function resolveIAiSubdomainUrl(subdomain: string, hostname?: string) {
  const rootDomain = resolvePlatformRootDomain(hostname);
  if (!rootDomain) {
    return "";
  }
  return `https://${subdomain}.${rootDomain}`;
}
